/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import UserInfo from '../components/UserInfo';
import {
  CenteredContainer,
  Heading,
  VariableText,
} from '../components/Typography';
import DataTable from '../components/Table';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { SERVICES } from '../components/Services';
// import fetchData from '../components/FetchData';
import DownloadIcon from '@mui/icons-material/Download';
import { get } from '../components/ApiHandler/apihandler';
import { toast } from 'react-toastify';
import Loader from '../components/Loader/Loader';
import NoData from '../components/NoData';
import { Helmet } from 'react-helmet';

const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: none;
  background: rgba(0, 0, 0, 0);
  color: #53a8a0;
  cursor: pointer;
  text-align: center;
`;

const Text = styled(VariableText)`
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const UserBoxx = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 80%;
  margin: auto;
  background: #e3f0ff;
  @media (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
  }
`;

const ContRicipt = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: auto;
  background: #fff;
  flex-direction: column;
  padding-left: 20px;
  width: 50%;
  @media (max-width: 1024px) {
    width: 100%;
    padding-left: 0;
    padding: 15px;
    box-sizing: border-box;
  }
`;
const pageSize = 5;
const ContributionHistory = () => {
  const memberId = useSelector((state) => state.member.memberId);
  // const dispatch = useDispatch();
  const [contributionData, setContribuionData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // const [pageSize, setPageSize] = useState(10);

  // const handlePageChange = (event, newPage) => {
  //   setCurrentPage(newPage);
  // };
  // const handleRowsPerPageChange = (event) => {
  //   setPageSize(parseInt(event.target.value, 10));
  //   setCurrentPage(0);
  // };

  // const fetchContData = useCallback(async () => {
  //   const url = `${SERVICES.CONTRIBUTION_DETAILS(
  //     memberId
  //   )}?page=${currentPage}&size=${pageSize}`;
  //   await fetchData(url, setContribuionData);
  // }, [memberId]);

  const fetchContData = async () => {
    const url = `${SERVICES.CONTRIBUTION_DETAILS(
      memberId
    )}?status=SUCCESS&page=${currentPage}&size=${pageSize}`;
    const response = await get(url);
    try {
      setIsLoading(true);
      if (response.ok) {
        const data = await response.json();
        setContribuionData(data.data);
      } else {
        toast.error('Something Went Wrong', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContData();
  }, []);

  const handlePageChange = async (selectedPage) => {
    setCurrentPage(selectedPage);
    try {
      setIsLoading(true);
      const url = `${SERVICES.CONTRIBUTION_DETAILS(
        memberId
      )}?status=SUCCESS&page=${selectedPage}&size=${pageSize}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setContribuionData(data.data);
      } else {
        console.error('Failed to fetch contribution data');
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchReceiptData = useCallback(
    async (paymentOrderId) => {
      const url = `${HOST1}/contribution/api/members/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
      try {
        const xAuthToken = localStorage.getItem('X-Auth-Token');
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'X-Auth-Token': xAuthToken,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message);
        }

        const data = await response.json();
        const redirect = data.data;
        if (redirect) {
          window.open(redirect, '_blank');
        }
      } catch (error) {
        console.error(error);
        const errorMessage = error.message || 'An error occurred';
        toast.error(errorMessage, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    },
    [memberId]
  );

  useEffect(() => {
    if (contributionData.content) {
      const updatedTableData = contributionData.content.map((item, index) => {
        const createdAt = new Date(item.createdAt);
        const serialNumber = currentPage * pageSize + index + 1;
        const formattedDate = `${createdAt
          .getDate()
          .toString()
          .padStart(2, '0')}-${(createdAt.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${createdAt.getFullYear()}`;

        return {
          id: item.id,
          column1: serialNumber,
          column2: formattedDate,
          column3: item.amount ? item.amount.toString() + '.00' : '',
          column4: (
            <Button onClick={() => fetchReceiptData(item.id)}>
              <DownloadIcon />
              Receipt
            </Button>
          ),
        };
      });
      setTableData(updatedTableData);
    }
  }, [contributionData.content]);
  const tableHeaders = ['S. No.', 'Date', 'Amount', 'Download Receipt'];
  const TITLE = 'Contribution History - BSG Contribution Site';
  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <UserBoxx>
        <UserInfo />
        <ContRicipt>
          <Heading margin="20px">Contribution Receipt</Heading>
          <CenteredContainer>
            <Text
              fontWeight="500"
              size="16px"
              color="#484848"
              style={{ width: '100%', textAlign: 'left' }}
            >
              Thank You very much for your sincere and precious contribution for
              kosen-rufu.
            </Text>
          </CenteredContainer>
          <CenteredContainer style={{ marginTop: '0' }}>
            <Text
              fontWeight="500"
              Size="16px"
              color="#484848"
              style={{ width: '100%', textAlign: 'left' }}
            >
              Following is the list of your contribution(s) to Bharat Soka
              Gakkai the current and last financial year. Write to us at{' '}
              <a href="mailto:contribution@bharatsokagakkai.org">
                contribution@bharatsokagakkai.org
              </a>
            </Text>
          </CenteredContainer>
          {tableData?.length ? (
            <DataTable
              data={tableData}
              contributionData={contributionData}
              headers={tableHeaders}
              // rowsPerPageOptions={[1, 5, 10, 25]}
              onPageChange={handlePageChange}
            />
          ) : (
            !tableData?.length && isLoading === false && <NoData />
          )}
          {/* <DataTable
          data={tableData}
          contributionData={contributionData}
          headers={tableHeaders}
          // rowsPerPageOptions={[1, 5, 10, 25]}
          onPageChange={handlePageChange}
        /> */}
          {isLoading && <Loader />}
        </ContRicipt>
      </UserBoxx>
    </div>
  );
};

export default ContributionHistory;
